import type { Duration, GuestKind, Mode, PassOptions } from './availability';

export interface HomeOrderInput {
  opts: PassOptions;
  guest: GuestKind;
  /** passesRequireModel of the object: the model is picked from a list only the full form has. */
  requireModel: boolean;
  /** Number of the object's vehicle types: a type must be chosen in the full form. */
  vehicleTypes: number;
  /** Addresses of the object that are not blocked: with several the full form asks which one. */
  usableAddresses: number;
}

export type HomeOrderRoute = { kind: 'order'; duration: Duration; mode: Mode } | { kind: 'form' } | { kind: 'unavailable' };

/**
 * Where «Заказать пропуск» on the home screen goes: straight to a pass (or an approval request), to the full
 * form when the object needs details the home screen does not ask for, or nowhere when the guest kind is off.
 */
export function homeOrderRoute({ opts, guest, requireModel, vehicleTypes, usableAddresses }: HomeOrderInput): HomeOrderRoute {
  const list = opts.durations(guest);
  if (!list.length) return { kind: 'unavailable' };
  if (usableAddresses > 1 || (guest === 'vehicle' && (requireModel || vehicleTypes > 0))) return { kind: 'form' };
  const pick = list.find((d) => d.duration === 'oneTime') ?? list[0];
  return { kind: 'order', ...pick };
}
